<template>
  <div id="head">
    <div class="head-logo">
      <img :src="logoImgUrl" :style="logoStyle" alt />
    </div>
    <div class="head-nav" v-if="!mixScene">
      <es-menu
        ref="menu"
        @select="routerSelect"
        :default-active="activeIndex"
        background-color="#353535"
        text-color="#fff"
        theme="dark"
        class="head-menu"
        mode="horizontal">
        <es-menu-item index="home">{{ $t('首页') }}</es-menu-item>
        <es-menu-item index="process">{{ !isOrg ? $t('我的文件') : $t('企业文件') }}</es-menu-item>
        <es-menu-item index="templates">{{ !isOrg ? $t('我的模板') : $t('企业模板') }}</es-menu-item>
        <es-menu-item index="approve-manage/list" v-show="isOrg">{{ $t('审批管理') }}</es-menu-item>
        <es-menu-item index="user/info">{{ $t('用户中心') }}</es-menu-item>
        <es-menu-item index="cost">{{ $t('费用中心') }}</es-menu-item>
        <es-menu-item index="cunZheng" v-show="!isDingtalk">{{ $t('证据中心') }}</es-menu-item>
      </es-menu>
      <div class="head-info">
        <div class="head-drop">{{ userInfo.name }}</div>
        <es-dropdown trigger="click" @command="dropChange" size="medium" v-show="!isDingtalk">
          <i class="es-icon-arrow-down es-icon--right"></i>
          <es-dropdown-menu slot="dropdown">
            <es-dropdown-item style="color: #999" divided>{{ $t('退出') }}</es-dropdown-item>
          </es-dropdown-menu>
        </es-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getTokenParams } from './../tokenLogin.js'
import axios from 'axios'
import { getLocale } from '@/locales'
import logoImgEn from '../assets/common/logo_en.png'
import logoImg from '../assets/common/logo.png'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      mixScene: state => state.mixScene,
    }),

    logoImgUrl() {
      if (getLocale() === 'en-US') {
        return logoImgEn
      }

      return logoImg
    },

    logoStyle() {
      if (getLocale() === 'en-US') {
        return 'transform: scale(1.6);'
      }

      return 'transform: none;'
    },
  },
  data() {
    return {
      activeIndex: this.$route.meta.nav,
    }
  },
  watch: {
    $route(to) {
      this.activeIndex = to.meta.nav
    },
  },
  mounted() {},
  methods: {
    async routerSelect(key) {
      const params = await getTokenParams()

      if (key === 'cunZheng') {
        this.$refs.menu.activeIndex = 'MyOrder'
        window.location.href = `${this.$Dic.getDefaultURL().cunUrl}?${params}`
      } else if (key === 'cost') {
        this.$router.push({ path: 'MyOrder' })
      } else {
        const baseURL = this.isDingtalk ? this.$Dic.getDefaultURL().dingURL : this.$Dic.getDefaultURL().baseURL
        window.location.href = `${baseURL}/${key}?${params}`
      }
    },
    dropChange() {
      this.goOut()
    },
    goOut() {
      this.$ajax(this.$url.logout(), {}).then(() => {
        localStorage.clear()
        axios
          .get(this.$url.getInfo().url, {
            transformRequest: [
              function (data, headers) {
                if (headers['X-Tsign-Open-App-Id']) {
                  delete headers['X-Tsign-Open-App-Id']
                }
                if (headers['X-Tsign-Open-Authorizer-Token']) {
                  delete headers['X-Tsign-Open-Authorizer-Token']
                }
                if (headers['X-Tsign-Open-Authorization-Version']) {
                  delete headers['X-Tsign-Open-Authorization-Version']
                }

                return data
              },
            ],
          })
          .then(res => {
            window.location.href = res.data.data.loginUrl
          })
      })
    },
  },
}
</script>
<style lang="less" scoped>
#head {
  padding: 0 8%;
  display: flex;
  height: 60px;
  flex-shrink: 0;
  overflow: hidden;
  background: #353535;
  .head-logo {
    width: 150px;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      max-width: 100%;
      height: auto;
      object-fit: contain;
    }
  }
  .head-nav {
    margin-left: 40px;
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    /deep/.es-menu--dark .es-menu-item {
      border-radius: 0;
    }
    /deep/.es-menu--dark.es-menu--horizontal .es-menu-item:not(.is-disabled):hover .es-menu-title__content {
      background-color: transparent;
    }
    /deep/.es-menu--horizontal > .es-menu-item:not(.is-disabled):focus {
      font-weight: 600;
      border-bottom: 2px solid #1063f1 !important;
    }
  }
  .head-line {
    color: rgba(76, 76, 76, 1);
    margin: 0 10px;
  }
  .head-new {
    position: relative;
    width: 16px;
    height: 16px;
    margin-top: 22px;
    background: url('../assets/use/new.png') no-repeat center;
    background-size: cover;
    cursor: pointer;
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      background: rgba(230, 23, 23, 1);
      font-size: 8px;
      font-weight: 500;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      line-height: 14px;
      position: absolute;
      top: -5px;
      right: -5px;
      border-radius: 100%;
    }
  }
  .head-info {
    display: flex;
    line-height: 60px;
  }
  .head-drop,
  i {
    cursor: pointer;
    font-size: 14px;
    transition: 0.3s all;
    color: rgba(153, 153, 153, 1);
    &:hover {
      color: #dedede;
    }
  }
  .head-menu {
    border-bottom: none;
    /deep/.es-menu-title__content:hover {
      background-color: rgb(42, 42, 42);
    }
  }
}
.out {
  font-size: 14px;
  color: #fff;
  position: absolute;
  right: 100px;
  cursor: pointer;
  height: 60px;
  line-height: 60px;
}
/deep/ .is-active {
  background: #353535 !important;
}
</style>
